<template>
  <div class="footer">
    <div class="footer-box" style=";">
      <a href="JavaScript:void(0)" style="font-size: 14px;font-weight: 500;
color: #868686;">{{$store.getters.systemConfig.notaryName}}</a>
      <span style="color: #868686">咨询电话：<span style="color: #2C69EC;">{{$store.getters.systemConfig.notaryPhone}}</span></span>
      <template v-if="!token">
        <span style="color: #868686">{{$store.getters.systemConfig.icp}}</span>
        <span style="font-size: 14px;font-weight: 500;color: #868686;">友情链接：
          <a href="https://www.ebaoquan.org/" style="
  color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF">易保全</a>
          <a href="https://www.junziqian.com/" style="
  color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF;margin: 0 20px">君子签</a>
          <a href="https://www.wbq360.com/" style="
  color: #BFBFBF;font-size: 14px;border-bottom: 1px solid #BFBFBF">微版权</a>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'indexFooter',
  computed: {
    ...mapState(['token'])
  },
}
</script>

<style scoped lang="less">
.footer{
  width: 100%;
  min-height: 60px;
  background: #FAFAFA;
  .footer-box{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 20px;
    align-items: center;
    min-height: 60px;
    font-size: 14px;
    font-weight: 500;
    flex-wrap: wrap;
    color: #fff
  }
}
@media (max-width: 600px) {
  .footer{
    .footer-box{
      flex-direction: column;
      flex-wrap: nowrap;
      &>*{
        //width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexFooter.vue